
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Web-Elements/Tree.html",
      function () {
        return require("private-next-pages/Web-Elements/Tree.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Web-Elements/Tree.html"])
      });
    }
  